// src/pages/Services.jsx
import React from "react";
import { Link } from "react-router-dom";
import { servicesData } from "../pages/servicesData";
import { Helmet } from "react-helmet-async";

export default function Services() {


  return (
    <div>
        <Helmet>
  <title>Physiotherapy, Chiropractic & Rehab Services | BrightLife</title>
  <meta
    name="description"
    content="Explore our physiotherapy, sports rehab, chiropractic, posture correction and pain management services in Hyderabad."
  />
</Helmet>
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  Services
                </h1>
                <nav>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active">Services</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="our-service">
        <div className="container">
          <div className="row align-items-center section-row">
            <div className="col-lg-7">
              <div className="section-title">
                <h3 className="wow fadeInUp">Our Services</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  <span>We Provide</span> The Best Services
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            {servicesData.map((s, idx) => (
              <div className="col-lg-4 col-md-6" key={s.id}>
                <div className="blog-item wow fadeInUp" data-wow-delay={`${0.05 * idx}s`}>
                  <div className="post-featured-image" data-cursor-text="View">
                    <figure>
                      <Link to={`/services/${s.id}`} className="image-anime">
                        <img loading="lazy" src={s.img} alt={s.title} />
                      </Link>
                    </figure>
                  </div>

                  <div className="post-item-content">
                    <div className="post-item-body">
                      <h2>
                        <Link to={`/services/${s.id}`}>{s.title}</Link>
                      </h2>
                      {/* <p>{s.excerpt}</p> */}
                    </div>
                    {/* <div className="post-item-footer">
                      <Link to={`/services/${s.id}`} className="btn-default">
                        Read More
                      </Link>
                    </div> */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
